import Vue from "vue";

export default {
    namespaced: true,
  
    state: {
        busyStatus: {}
    },

    mutations: {
        setBusyTable (state, payload) {
            const { billId, status } = payload;
            Vue.set(state.busyStatus, billId, status);
        },
        

        alertErrorNotify (state, data) {
        },
        
        alertSuccessNotify (state, data) {
            
        }
    }
}